"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnreadItemType = void 0;
exports.UnreadItemType = {
    QMS: 1,
    Mention: 2,
    Favorite: 3
};
